import { ImageProps } from '@src/quince-components/src'

import ContentfulImage from './contentful/ContentfulImage'
import Link from './Link'

export type IMAGE_LOADING_TYPE = 'eager' | 'lazy'

interface IImage {
  readonly id: string
  readonly title?: string
  readonly description?: string
  readonly url: string
  readonly fileName: string
  readonly width: number
  readonly height: number
  readonly loading?: IMAGE_LOADING_TYPE
  quality?: number
  readonly link?: Link
  alt?: string
  readonly className?: string
}

export default class Image implements IImage {
  readonly id: string
  readonly title: string
  readonly description: string
  readonly url: string
  readonly fileName: string
  readonly height: number
  readonly width: number
  readonly className?: string

  quality: number
  loading?: IMAGE_LOADING_TYPE
  readonly link?: Link
  alt?: string

  constructor({
    title = '',
    description = '',
    url,
    fileName,
    id,
    height,
    width,
    loading,
    quality = 50,
    link,
    alt,
    className,
  }: IImage) {
    this.id = id
    this.title = title
    this.description = description
    this.url = url
    this.fileName = fileName
    this.height = height
    this.width = width
    this.loading = loading
    this.quality = quality > 100 ? 100 : quality
    this.link = link
    this.alt = alt
    this.className = className

    return {
      ...this,
    }
  }

  static makeImageProps(image?: Image, link?: Link): ImageProps {
    if (!image) {
      return {
        url: '',
        title: '',
        alt: '',
        height: 100,
        width: 100,
      }
    }
    return {
      url: image.url,
      title: image.title,
      id: image.id,
      description: image.description,
      fileName: image.fileName,
      height: image.height,
      width: image.width,
      loading: image.loading,
      quality: image.quality,
      link: link,
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      alt: image.alt || image.title || 'image',
    }
  }

  static fromContentful(contentfulImage: ContentfulImage | undefined) {
    return new Image({
      title: contentfulImage?.title ?? '',
      description: contentfulImage?.description ?? '',
      url: contentfulImage?.file.url ?? '',
      fileName: contentfulImage?.file.fileName ?? '',
      id: contentfulImage?.id ?? '',
      height: contentfulImage?.file.details.image.height ?? 0,
      width: contentfulImage?.file.details.image.width ?? 0,
      loading: contentfulImage?.loading ?? 'lazy',
    })
  }
}
